import React, { useEffect, useState } from 'react';
import { getCitiesAndGraftByPostalCode, getCitiesByPostalCode, getPostalCodes } from '../../../services/postal_code_service';
import { PressData } from '../../../models/listpress';
import { ToastContainer, toast } from 'react-toastify';
import { isValidPostalCode } from '../../../utils/functions/validatePostalCode';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { isValidRcs } from '../../../utils/functions/validateRCSNumber';
import axios from '../../../api/axios';
import TabsNavigation from './OngletforAssiste';


interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}
interface ManagerStateInterface {
    personne: string;
    civilite: string;
    nom: string;
    prenom: string;
    rcs: string;
    adresse: string;
    adressesuite: string;
    codepostal: string;
    codepostal1: string;
    ville: string;
    greffe: string;
    communes: string[];
    communes1: string[];
    denomination2: string;
    adressephysique: string;
    adressesuitephysique: string;
    codepostal3: string;
    ville1: string;
    ville2: string;
}

const CreationAutreHorsForfait: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {
    const [errors, setErrors] = useState<{
        denomination1?: string;
        Nature?: string;
        dateeacte?: string;
        texteAnnonce?: string
        Formejuridique?: String;
        objets?: string;
        capital?: string;
        Duree?: string;
        adresse?: string;
        ville?: string;
        postalCode?: string;
        greffe?: string;
        nom?: string;
        prenom?: string;
        adressepysique?: string;
        codepostal?: string;
        villepysique?: string;
        adressep?: string;
        villep?: string;
        rcsmorale?: string;
        denominationmorale?: string;
        adressephysiquemorale?: string;
        codepostalmorale?: string;
        villemorale?: string;
        capitalmorale?: string;
        greffemorale?: string;
    }>({});
    const [isTextareaVisible, setIsTextareaVisible] = useState(false);
    const [date, setDate] = useState<string>('');
    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [commune, setSelectedCommune] = useState<string>("");
    const [communes, setCommunes] = useState<string[]>([]);
    const [postalCode, setPostalCode] = useState<number | null>(null);
    const [filteredPressData, setFilteredPressData] = useState<PressData[]>([]);
    const [pressData, setPressData] = useState<PressData[]>([]);
    const [postalCode1, setPostalCode1] = useState<number | null>(null);
    const [communes1, setCommunes1] = useState<string[]>([]);
    const [typeChoice, setTypeChoice] = useState('');
    const options = Array.isArray(societyType) ? societyType : [societyType];
    // const handleSelectChangeSociete = (event: React.ChangeEvent<HTMLSelectElement>) => {
    //     setTypeChoice(event.target.value);
    // };
    const [isFocuseed, setIsFocuseed] = useState(false);
    const [isFocuseed1, setIsFocuseed1] = useState(false);
    const [isFocuseed2, setIsFocuseed2] = useState(false);
    const [isFocuseed3, setIsFocuseed3] = useState(false);
    const [isFocuseed4, setIsFocuseed4] = useState(false);
    const [isFocuseed5, setIsFocuseed5] = useState(false);
    const [isFocuseed6, setIsFocuseed6] = useState(false);
    const [isFocuseed7, setIsFocuseed7] = useState(false);
    const [isFocuseed8, setIsFocuseed8] = useState(false);
    const [isFocuseed9, setIsFocuseed9] = useState(false);

    const [displayText, setDisplayText] = useState('');
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const handleSelectChangeSociete = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        setTypeChoice(selectedValue);

        // Récupère l'index de l'option sélectionnée
        const index = options.indexOf(selectedValue);
        setSelectedIndex(index);
        console.log("Index sélectionné :", index);
    };

    // Mise à jour de displayText en fonction de l'index sélectionné
    useEffect(() => {
        if (selectedIndex === 0) {
            setDisplayText('AARPI');
        } else if (selectedIndex === 1) {
            setDisplayText('EURL');
        } else if (selectedIndex === 2) {
            setDisplayText('EARL')
        } else if (selectedIndex === 3) {
            setDisplayText('GAEC')
        } else if (selectedIndex === 4) {
            setDisplayText('GFA')
        } else if (selectedIndex === 5) {
            setDisplayText('SARL')
        }
        else if (selectedIndex === 6) {
            setDisplayText('SA')
        } else if (selectedIndex === 7) {
            setDisplayText('SC')
        } else if (selectedIndex === 8) {
            setDisplayText('SCM')
        } else if (selectedIndex === 9) {
            setDisplayText('SCEA')
        } else if (selectedIndex === 10) {
            setDisplayText('SCI')
        } else if (selectedIndex === 11) {
            setDisplayText('SCI')
        } else if (selectedIndex === 12) {
            setDisplayText('SCI')
        } else if (selectedIndex === 13) {
            setDisplayText('SPFPL SAS')
        } else if (selectedIndex === 14) {
            setDisplayText('SPFPL SASU')
        } else if (selectedIndex === 15) {
            setDisplayText('SELARL')
        } else if (selectedIndex === 16) {
            setDisplayText('SELAS')
        } else if (selectedIndex === 18) {
            setDisplayText('SELASU')
        } else if (selectedIndex === 19) {
            setDisplayText('SNC')
        }
        else if (selectedIndex === 20) {
            setDisplayText('SNC')
        } else if (selectedIndex === 21) {
            setDisplayText('SNC')
        } else if (selectedIndex === 22) {
            setDisplayText('SNC')
        } else if (selectedIndex === 23) {
            setDisplayText('SNC')
        } else if (selectedIndex === 14) {
            setDisplayText('SNC')
        }
        else {
            setDisplayText('');
        }
    }, [selectedIndex]);

    const handleChangeCompanyPostalCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Convertir la valeur en nombre ou null si elle est vide
        setPostalCode(value ? Number(value) : null);
        console.log("POSTAL CODE ", postalCode);
    };

    const handleInputChange3 = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = event.target.value;
        const updatedGerants = [...gerants];
        updatedGerants[index].codepostal = value;

        if (value && isValidPostalCode(value)) {
            try {
                const communeName = await getCitiesByPostalCode(Number(value));
                updatedGerants[index].communes = communeName;
                updatedGerants[index].ville = communeName[0]; // Default to the first option
            } catch (error) {
                console.error("Erreur lors de la récupération des communes:", error);
                updatedGerants[index].communes = [];
                updatedGerants[index].ville = '';
            }
        } else {
            updatedGerants[index].communes = [];
            updatedGerants[index].ville = '';
        }

        setGerants(updatedGerants);
    };

    const handleInputChange4 = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = event.target.value;
        const updatedGerants = [...gerants];
        updatedGerants[index].codepostal1 = value;

        if (value && isValidPostalCode(value)) {
            try {
                const data = await getCitiesAndGraftByPostalCode(Number(value));
                updatedGerants[index].communes = data.villes;
                updatedGerants[index].ville = data.villes[0];
                updatedGerants[index].greffe = data.greffe;
                setFormData({ ...formData, greffe1: data.greffe }) // Default to the first option
            } catch (error) {
                console.error("Erreur lors de la récupération des communes:", error);
                updatedGerants[index].communes = [];
                updatedGerants[index].ville1 = '';
            }
        } else {
            updatedGerants[index].communes = [];
            updatedGerants[index].ville1 = '';
        }

        setGerants(updatedGerants);
    };

    const handleInputChange5 = async (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = event.target.value;
        const updatedGerants = [...gerants];
        updatedGerants[index].codepostal3 = value;

        if (value && isValidPostalCode(value)) {
            try {
                const data = await getCitiesAndGraftByPostalCode(Number(value));
                updatedGerants[index].communes1 = data.villes;
                updatedGerants[index].ville2 = data.villes[0];
                updatedGerants[index].greffe = data.greffe;
                setFormData({ ...formData, greffe1: data.greffe }) // Default to the first option
            } catch (error) {
                console.error("Erreur lors de la récupération des communes:", error);
                updatedGerants[index].communes1 = [];
                updatedGerants[index].ville2 = '';
            }
        } else {
            updatedGerants[index].communes1 = [];
            updatedGerants[index].ville2 = '';
        }

        setGerants(updatedGerants);
    };

    const handleVilleChange = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
        const updatedGerants = [...gerants];
        updatedGerants[index].ville = event.target.value;
        setGerants(updatedGerants);
    };

    const handleVilleChange2 = (event: React.ChangeEvent<HTMLSelectElement>, index: number) => {
        const updatedGerants = [...gerants];
        updatedGerants[index].ville2 = event.target.value;
        setGerants(updatedGerants);
    };

    const handleInputChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCommune(event.target.value);
        setFormData({
            ...formData,
            ville: event.target.value
        })
    };

    useEffect(() => {
        // Mettre à jour postalCode1 dans formData
        setFormData(prevFormData => ({
            ...prevFormData,
            postalCode1: postalCode1 !== null ? postalCode1.toString() : ''
        }));
    }, [postalCode1]);


    useEffect(() => {
        // Mettre à jour postalCode1 dans formData
        setFormData(prevFormData => ({
            ...prevFormData,
            postalCode: postalCode !== null ? postalCode.toString() : ''
        }));
    }, [postalCode]);

    const handleAddGerant = () => {
        setGerants([
            ...gerants,
            {
                personne: 'option01',
                civilite: 'option01',
                ville1: '',
                nom: '',
                prenom: '',
                codepostal1: '',
                codepostal3: '',
                rcs: '',
                adresse: '',
                adressesuite: '',
                codepostal: '',
                ville: '',
                greffe: '',
                communes: [],
                communes1: [],
                denomination2: '',
                adressephysique: '',
                adressesuitephysique: '',
                ville2: '',
            },
        ]);
    };

    const handleRemoveLastGerant = () => {
        if (gerants.length > 1) {
            setGerants(gerants.slice(0, -1));
        }
    };

    const handleInputChange = async (
        index: number,
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = event.target;
        const newGerants = [...gerants];
        newGerants[index] = { ...newGerants[index], [name]: value };
        if (name == 'rcs' && isValidRcs(value)) {
            try {
                const res = await axios(`/rne/${value}`)
                newGerants[index] = {
                    ...newGerants[index],
                    denomination2: res.data.data.nom_complet,
                    adressephysique: res.data.data.geo_adresse,
                    codepostal3: res.data.data.code_postal,
                    communes1: res.data.data.villes,
                    ville2: res.data.data.villes?.[0]
                }
                setFormData({
                    ...formData, greffe1: res.data.data.greffe
                })

                setGerants(newGerants);
                console.log(newGerants)
            }
            catch (error: any) {
                console.log(error)
                if (error.response?.data?.message) {
                    toast.error(error?.response?.data?.message, { delay: 5000 })
                }
                else {
                    toast.error(error.message, { delay: 5000 })
                }
            }
        }
        setGerants(newGerants);
    };

    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode && isValidPostalCode(postalCode?.toString())) {
                try {
                    const res = await getCitiesAndGraftByPostalCode(postalCode)
                    if (Array.isArray(res.villes)) setCommunes(res.villes)
                    else setCommunes([])

                    setFormData({
                        ...formData,
                        ville: res.villes[0],
                        greffe: res.greffe
                    })
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes([]);
                }
            } else {
                setCommunes([]);
            }

        };

        fetchCommunes();
    }, [postalCode]);

    useEffect(() => {
        const fetchCommunes = async () => {
            if (postalCode1) {
                try {
                    const communeName = await getPostalCodes(postalCode1);
                    setCommunes1([communeName]);
                } catch (error) {
                    console.error("Erreur lors de la récupération des communes:", error);
                    setCommunes1([]);
                }
            } else {
                setCommunes1([]);
            }
        };

        fetchCommunes();
    }, [postalCode1]);

    useEffect(() => {
        if (postalCode && pressData.length > 0) {
            const departmentCode = postalCode.toString().substring(0, 2);
            const filteredData = pressData.filter(item => item.departement === departmentCode);
            setFilteredPressData(filteredData);
        } else {
            setFilteredPressData(pressData);
        }
    }, [postalCode, pressData]);
    const NatureActe = [
        { value: 'option01', label: 'acte authentique' },
        { value: 'option02', label: 'acte sous seing privé' },
    ];

    const FormeJuridique_societe = [
        { value: 'option01', label: '' },
        { value: 'option02', label: 'Entreprise Unipersonnelle à responsabilité limitée' },
    ];


    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }
    const Personnes = [
        { value: 'opti01', label: 'Personne physique' },
        { value: 'opti02', label: 'Personne morale' }
    ];
    const Civilite = [
        { value: 'op1', label: 'Monsieur' },
        { value: 'op2', label: 'Madame' },
    ];

    // Fonction pour valider le format de la date (JJ/MM/AAAA)
    const validateDate = (value: string) => {
        const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
        return regex.test(value);
    };
    let hasDisplayedError = false;

    const validate = () => {
        const newErrors: {
            denomination1?: string;
            villep?: string;
            greffe?: string;
            nom?: string;
            objetsocial?: string;
            texteAnnonce?: string;
            prenom?: string;
            capital?: string;
            Duree?: string;
            adressep?: string;
            codepostal?: string;
            rcsmorale?: string;
            denominationmorale?: string;
            adressephysiquemorale?: string;
            codepostalmorale?: string;
            villemorale?: string;
            capitalmorale?: string;
            greffemorale?: string;
        } = {};

        const errorFields: string[] = [];

        if (formData.personne === 'Personne physique') {
            gerants.forEach(gerant => {
                if (!gerant.nom) {
                    newErrors.nom = "Le champ 'nom' est obligatoire.";
                    errorFields.push("nom");
                }

                if (!gerant.prenom) {
                    newErrors.prenom = "Le champ 'prénom' est obligatoire.";
                    errorFields.push("prenom");
                }

                if (!gerant.adresse) {
                    newErrors.adressep = "Le champ 'adresse' est obligatoire.";
                    errorFields.push("adresse");
                }

                if (!gerant.codepostal) {
                    newErrors.codepostal = "Le champ 'code postal' est obligatoire.";
                    errorFields.push("codepostal");
                }

                if (!gerant.ville) {
                    newErrors.villep = "Le champ 'ville' est obligatoire.";
                    errorFields.push("codepostal");
                }
            });

        }

        // Validation pour "Personne morale"
        if (formData.personne === 'Personne morale') {
            gerants.forEach(gerant => {
                if (!gerant.rcs) {
                    newErrors.rcsmorale = "Le champ 'rcs' est obligatoire.";
                    errorFields.push("rcs");
                }
                if (!gerant.denomination2) {
                    newErrors.denominationmorale = "Le champ 'denomination' est obligatoire.";
                    errorFields.push("denomination");
                }
                if (!gerant.adressephysique) {
                    newErrors.adressephysiquemorale = "Le champ 'adresse' est obligatoire.";
                    errorFields.push("adresse");
                }
                if (!gerant.codepostal3) {
                    newErrors.codepostalmorale = "Le champ 'code postal' est obligatoire.";
                    errorFields.push("code postal");
                }
                if (!gerant.ville2) {
                    newErrors.villemorale = "Le champ 'ville' est obligatoire.";
                    errorFields.push("ville");
                }
                if (!formData.capital1) {
                    newErrors.capitalmorale = "Le champ 'capital' est obligatoire.";
                    errorFields.push("capital");
                }
                if (!formData.greffe1) {
                    newErrors.greffemorale = "Le champ 'greffe' est obligatoire.";
                    errorFields.push("greffe");
                }



            });
        }

        // Mise à jour des erreurs dans l'état
        setErrors(newErrors);

        // Retourne vrai si aucune erreur, sinon faux
        return Object.keys(newErrors).length === 0;
    };

    const formatDate = (isoDate: string): string => {
        if (!isoDate) return ''; // Si la valeur est vide, retourner une chaîne vide
        const [year, month, day] = isoDate.split('-'); // Séparer l'année, le mois et le jour
        return `${day}/${month}/${year}`; // Retourner la date au format JJ/MM/AAAA
    };
    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isoDate = e.target.value; // Date en format ISO (AAAA-MM-JJ)
        setFormData({ ...formData, dateeacte: isoDate }); // Mettre à jour l'état avec la date au format ISO
    };

    // Convertir une date ISO (AAAA-MM-JJ) en JJ/MM/AAAA


    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const [formData, setFormData] = useState({
        denomination1: '',
        denomination2: '',
        sigle: '',
        personnes: 'Personne physique',
        capital1: '',
        decision: '',
        personne: 'Personne physique',
        greffe1: '',
        Nature: 'option01',
        FormeJuridique_societe: '',
        date: '',
        rcs: '',
        capital: '',
        Duree: '',
        adresse: '',
        adressesuite: '',
        adresseeffet: '',
        formejuridique: '',
        objet: '',
        codePostal: '',
        ville: '',
        greffe: '',
        type: '',
        objetsocial: '',
        denomination1nouvelle: '',
        capitalnouveau: '',
        dateeffet: '',
        dateeacte: '',
        civiliteLiquidateur: '',
        nomliquidateur: '',
        prenomLiquidateur: '',
        adresseLiquidateur: '',
        adressesuiteLiquidateur: '',
        codepostalLiquidateur: '',
        villeLiquidateur: '',
        rcsLiquidateur: '',
        denominationliquidateur: '',
        capitalliquidateur: '',
        greffeLiquidateur: '',
        adresseliquidation: 'Au siège social',
        civilitesiegeLiquidateur: '',
        nomsiegeliquidateur: '',
        prenomsiegeLiquidateur: '',
        adressesiegeLiquidateur: '',
        adressesuitesiegeLiquidateur: '',
        codepostalSiegeLiquidateur: '',
        villeSiegeLiquidateur: '',
        saisiradresse: 'Non',
        adresseCorrespondant: '',
        adresseeffetCorrespondant: '',
        codePostalCorrespondant: '',
        villeCorrespondant: '',
        postalCode: '',
        postalCode1: postalCode1 !== null ? postalCode1.toString() : "",
        personness: 'Personne physique',
    })

    const [gerants, setGerants] = useState<ManagerStateInterface[]>([
        {
            personne: 'option01',
            civilite: 'option01',
            denomination2: '',
            codepostal1: '',
            nom: '',
            prenom: '',
            ville1: '',
            rcs: '',
            adresse: '',
            adressesuite: '',
            codepostal: '',
            ville: '',
            greffe: '',
            communes: [],
            communes1: [],
            adressephysique: '',
            adressesuitephysique: '',
            codepostal3: '',
            ville2: '',
        },
    ]);


    const [submittedData, setSubmittedData] = useState<{ [key: string]: string } | null>(null);

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();
        if (validate()) {
            // Filtrer les présidents pour s'assurer que les noms et prénoms sont remplis
            const validGerants = gerants.filter(gerant => gerant.nom && gerant.prenom);
            const validGerant_denomination = gerants.filter(gerant => gerant.denomination2 && gerant.rcs);
            const presidentSection = validGerants.length > 0
                ? `Gérance : ${validGerants.map((gerant) => `M.${gerant.nom} ${gerant.prenom}, demeurant à ${gerant.adresse || ''} ${gerant.adressesuite || ''} ${gerant.codepostal || ''} ${gerant.ville || ''}`).join('\n')}`
                : ""; // Si la liste filtrée est vide, la section restera vide.
            const gerant_denomination = validGerant_denomination.length > 0
                ? `Gérance : ${validGerant_denomination.map((gerant) => ` ${gerant.denomination2 || ''}, ${displayText || 'la creation autre forfaits'} au capital de ${formData.capital1 || ''} € , ayant son siège social ${gerant.adressephysique || ''} ${gerant.adressesuitephysique || ''} ${gerant.codepostal3 || ''} ${gerant.ville2 || ''}, ${gerant.rcs || ''} RCS de ${formData.greffe1 || ''} `).join('\n')}`
                : ""; // Si la liste filtrée est vide, la section restera vide.


            // Construire un tableau des sections non vides
            const sections = [
                presidentSection,
                gerant_denomination
            ];
            // Filtrer les sections vides, puis rejoindre avec un seul saut de ligne
            const filteredSections = sections.filter(section => section.trim() !== "").join('\n\n'); // Enlever les sections vides et les espaces supplémentaires

            // Si aucune section n'est remplie, il n'y aura pas d'ajout d'espace
            const textContent = `Par ${NatureActe.find(option => option.value === formData.Nature)?.label} du ${formatDate(formData.dateeacte)}, il a été constitué la creation autre forfaits ayant les caractéristiques suivantes :
Dénomination: ${formData.denomination1}
Sigle: ${formData.sigle}
Objet social: ${formData.objet}
Siège social: ${formData.adresse} ${formData.adressesuite} ${postalCode || ''} ${formData.ville || ''}
Capital: ${formData.capital}€
Durée: ${formData.Duree}
${filteredSections}
Immatriculation au RCS de ${formData.greffe || ''}`;
            const filteredTextContent = textContent.replace(/\n\s*\n/g, '\n');
            // Utilisez updateTxtAnnonce pour afficher le texte
            updateTxtAnnonce(filteredTextContent);

            // Stockez les autres informations nécessaires
            setSubmittedData(formData);
            updateDenomination(formData.denomination1);
            setIsTextareaVisible(true);
            console.log("formData complet:", formData);
        }
        console.log(formData);
        const isValid = validate();
        if (isValid) {
            setFormSubmitted(true);
        }
    };




    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };
    const handleNext = () => {
        console.log("visited", visitedTabs);
        console.log("active", activeTab);

        if (activeTab === 'raisonSociale') {
            if (formData.denomination1.trim() === '') {
                setErrors({ ...errors, denomination1: 'Ce champ est obligatoire.' });
                return;
            }
            setErrors({ ...errors, denomination1: '' });
            setActiveTab('signatureDesStatus');
            if (!visitedTabs.includes('signatureDesStatus')) {
                setVisitedTabs([...visitedTabs, 'signatureDesStatus']);
            }
        } else if (activeTab === 'signatureDesStatus') {
            if (!formData.Nature || !formData.dateeacte) {
                setErrors({
                    ...errors,
                    Nature: formData.Nature ? '' : 'Veuillez sélectionner une nature.',
                    dateeacte: formData.dateeacte ? '' : 'Veuillez entrer une date valide.',
                });
                return;
            }
            setErrors({ ...errors, Nature: '', dateeacte: '' });
            setActiveTab('laSociété');
            if (!visitedTabs.includes('laSociété')) {
                setVisitedTabs([...visitedTabs, 'laSociété']);
            }
        } else if (activeTab === 'laSociété') {
            if (!formData.FormeJuridique_societe || !formData.objet || !formData.capital || !formData.Duree) {
                setErrors({
                    ...errors,
                    Formejuridique: formData.FormeJuridique_societe ? '' : 'Veuillez sélectionner une forme juridique.',
                    objets: formData.objet ? '' : 'Veuillez entrer un objet.',
                    capital: formData.capital ? '' : 'Veuillez entrer le montant.',
                    Duree: formData.Duree ? '' : 'Veuillez entrer la durée.',
                });
                return;
            }
            setErrors({ ...errors, Formejuridique: '', objets: '', capital: '', Duree: '' });
            setActiveTab('adresseDuSiegeSocial');
            if (!visitedTabs.includes('adresseDuSiegeSocial')) {
                setVisitedTabs([...visitedTabs, 'adresseDuSiegeSocial']);
            }
        } else if (activeTab === 'adresseDuSiegeSocial') {
            if (!formData.adresse || !formData.ville || !postalCode || !formData.greffe) {
                setErrors({
                    ...errors,
                    adresse: formData.adresse ? '' : 'Veuillez entrer une adresse.',
                    ville: formData.ville ? '' : 'Veuillez entrer une ville.',
                    postalCode: postalCode ? '' : 'Veuillez entrer le code postal.',
                    greffe: formData.greffe ? '' : 'Veuillez entrer le greffe.',
                });
                return;
            }
            setErrors({ ...errors, adresse: '', ville: '', postalCode: '', greffe: '' });
            setActiveTab('laGérance');
            if (!visitedTabs.includes('laGérance')) {
                setVisitedTabs([...visitedTabs, 'laGérance']);
            }
        }
    };


    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
    };
    const handleChangemax = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        let newValue = Math.min(Number(value), 99); // Limite maximale à 99
        newValue = Math.max(newValue, 0); // Limite minimale à 0 (empêche les négatifs)

        setFormData((prevData) => ({
            ...prevData,
            [id]: newValue,
        }));
    };



    // const getNextTab = (currentTab: string) => {
    //     switch (currentTab) {
    //         case 'raisonSociale':
    //             return 'signatureDesStatus';
    //         case 'signatureDesStatus':
    //             return 'laSociété';
    //         case 'laSociété':
    //             return 'adresseDuSiegeSocial';
    //         case 'adresseDuSiegeSocial':
    //             return 'laGérance';
    //         default:
    //             return currentTab;
    //     }
    // };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'signatureDesStatus':
                return 'raisonSociale';
            case 'laSociété':
                return 'signatureDesStatus';
            case 'adresseDuSiegeSocial':
                return 'laSociété';
            case 'laGérance':
                return 'adresseDuSiegeSocial';
            default:
                return currentTab;
        }
    };
    return (
        <>
            <TabsNavigation activeTab={activeTab} onTabClick={setActiveTab} />

            <ToastContainer />
            <form onSubmit={handleSubmit}>
                {activeTab === 'raisonSociale' && (
                    <div className="tab-content">
                        <p>
                            <strong>
                                Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce. En optionnel, vous pouvez ajouter une référence client.
                            </strong>
                        </p>
                        <div className="mb-3 row">
                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">
                                Dénomination <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-sm-10">
                                <input
                                    className={`form-control ${errors.denomination1 ? 'is-invalid' : ''}`} // Ajout de la classe d'erreur si nécessaire
                                    type="text"
                                    id="denomination1"
                                    value={formData.denomination1}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.denomination1 && (
                                    <div className="invalid-feedback">
                                        {errors.denomination1}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'signatureDesStatus' && (
                    <div className="row">
                        <div className="tab-content">
                            <div className="mb-3 row">
                                <label htmlFor="Nature" className="col-sm-2 col-form-label">
                                    Nature de l'acte <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10 mb-3">
                                    <select
                                        className={`form-select ${errors.Nature ? 'is-invalid' : ''}`}
                                        id="Nature"
                                        onChange={handleChange}
                                        value={formData.Nature}
                                        required
                                    >
                                        {NatureActe.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.Nature && <div className="invalid-feedback">{errors.Nature}</div>}
                                </div>

                                <label htmlFor="dateeacte" className="col-sm-2 col-form-label">
                                    Date d'effet <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10 mb-3">
                                    <input
                                        className={`form-control ${errors.dateeacte ? 'is-invalid' : ''}`}
                                        type="date"
                                        id="dateeacte"
                                        value={formData.dateeacte}
                                        onChange={handleDateChange}
                                        required
                                    />
                                    {errors.dateeacte && (
                                        <div className="invalid-feedback">
                                            {errors.dateeacte}
                                        </div>
                                    )}
                                </div>

                                {isFocuseed && (
                                    <span style={{ display: 'block', marginTop: '5px' }}>
                                        <p style={{
                                            backgroundColor: '#3EA3B2',
                                            color: 'white',
                                            padding: '10px',
                                            borderRadius: '4px',
                                            margin: 0,
                                            width: '25%',
                                            boxSizing: 'border-box'
                                        }}>
                                            EXPLICATION<br />
                                            Date de création de la société, doit être identique à celle de la page de signature des statuts de la société.
                                        </p>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                )}
                {activeTab === 'laSociété' && (
                    <div className="tab-content">
                        <div className="mb-3 row">
                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">
                                Dénomination <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className='col-sm-10 mb-2'>
                                <input
                                    className={`form-control ${errors.denomination1 ? 'is-invalid' : ''}`}
                                    type="text"
                                    id="denomination1"
                                    value={formData.denomination1}
                                    onChange={handleChange}
                                    onFocus={() => setIsFocuseed1(true)}
                                    onBlur={() => setIsFocuseed1(false)}
                                />
                            </div>
                            {isFocuseed1 && (
                                <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                    <p style={{
                                        backgroundColor: '#3EA3B2',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        margin: 0,
                                        width: '30%',
                                        boxSizing: 'border-box'
                                    }}>
                                        EXPLICATION<br />
                                        Nom de la société, doit être identique à celui de vos statuts.
                                    </p>
                                </span>
                            )}
                            <label htmlFor="sigle" className="col-sm-2 col-form-label">Sigle</label>
                            <div className="col-sm-10 mb-2">
                                <input
                                    className="form-control"
                                    type="text"
                                    id="sigle"
                                    value={formData.sigle}
                                    onChange={handleChange}
                                    onFocus={() => setIsFocuseed2(true)}
                                    onBlur={() => setIsFocuseed2(false)}
                                />
                            </div>
                            {isFocuseed2 && (
                                <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                    <p style={{
                                        backgroundColor: '#3EA3B2',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        margin: 0,
                                        width: '30%',
                                        boxSizing: 'border-box'
                                    }}>
                                        EXPLICATION<br />
                                        Ensemble de lettres servant d'abréviation. A saisir uniquement si vous l'avez précisé dans vos statuts.
                                    </p>
                                </span>
                            )}
                            <label htmlFor="sociteChoice" className="col-sm-2 col-form-label">
                                Forme juridique <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className='col-sm-10 mb-2'>
                                <select
                                    className={`form-select ${errors.Formejuridique ? 'is-invalid' : ''}`}
                                    id="FormeJuridique_societe"
                                    onChange={handleChange}
                                    value={formData.FormeJuridique_societe}
                                >
                                    {/* Mapping options for NatureActe */}
                                    {FormeJuridique_societe.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.Formejuridique && <div className="invalid-feedback">{errors.Formejuridique}</div>}
                            </div>
                            <label htmlFor="objet" className="col-sm-2 col-form-label">
                                Objet <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-sm-10 mb-2">
                                <textarea
                                    className={`form-control ${errors.objets ? 'is-invalid' : ''}`}
                                    id="objet"
                                    value={formData.objet}
                                    onChange={handleChange}
                                    rows={3}
                                    onFocus={() => setIsFocuseed3(true)}
                                    onBlur={() => setIsFocuseed3(false)}
                                />
                                {errors.objets && <div className="invalid-feedback">{errors.objets}</div>}
                            </div>
                            {isFocuseed3 && (
                                <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                    <p style={{
                                        backgroundColor: '#3EA3B2',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        margin: 0,
                                        width: '30%',
                                        boxSizing: 'border-box'
                                    }}>
                                        EXPLICATION<br />
                                        Saisir l'activité principale de la société. Ne ps mentionner les activités annexes ou de type : Et, plus généralement, toutes opérations industrielles, commerciales, financières, mobilières ou immobilières...
                                    </p>
                                </span>
                            )}
                            <label htmlFor="capital" className="col-sm-2 col-form-label">
                                Capital <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-sm-10 mb-2">
                                <input
                                    className={`form-control ${errors.capital ? 'is-invalid' : ''}`}
                                    type="number"
                                    id="capital"
                                    value={formData.capital}
                                    onChange={handleChange}
                                    onFocus={() => setIsFocuseed4(true)}
                                    onBlur={() => setIsFocuseed4(false)}
                                />
                                {errors.capital && (
                                    <div className="invalid-feedback">
                                        {errors.capital}
                                    </div>
                                )}

                            </div>
                            {isFocuseed4 && (
                                <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                    <p style={{
                                        backgroundColor: '#3EA3B2',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        margin: 0,
                                        width: '30%',
                                        boxSizing: 'border-box'
                                    }}>
                                        EXPLICATION<br />
                                        Montant du capital tel que mentionné dans les statuts. Par exemple : 1535,65
                                    </p>
                                </span>
                            )}
                            <label htmlFor="Duree" className="col-sm-2 col-form-label">
                                Durée <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-sm-10 mb-2">
                                <input
                                    className={`form-control ${errors.Duree ? 'is-invalid' : ''}`}
                                    type="number"
                                    id="Duree"
                                    value={formData.Duree}
                                    onChange={handleChangemax}
                                    onFocus={() => setIsFocuseed5(true)}
                                    onBlur={() => setIsFocuseed5(false)}
                                    max={99}
                                    min={0}
                                />
                                {errors.Duree && <div className="invalid-feedback">{errors.Duree}</div>}
                            </div>

                            {isFocuseed5 && (
                                <span style={{ display: 'block', marginTop: '5px', marginLeft: '170px', marginBottom: '10px' }}>
                                    <p style={{
                                        backgroundColor: '#3EA3B2',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        margin: 0,
                                        width: '30%',
                                        boxSizing: 'border-box'
                                    }}>
                                        EXPLICATION<br />
                                        La durée de la société ne peut excéder 99 ans, elle pourra être prorogée une ou plusieurs fois.
                                    </p>
                                </span>
                            )}

                        </div>
                    </div>
                )}
                {activeTab === 'adresseDuSiegeSocial' && (
                    <div className="mb-3 row">
                        <div className="tab-content">
                            <div className="mb-3 row">
                                <label htmlFor="adresse" className="col-sm-2 col-form-label">
                                    Adresse <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10">
                                    <input
                                        className={`form-control ${errors.adresse ? 'is-invalid' : ''}`}
                                        type="text"
                                        id="adresse"
                                        value={formData.adresse}
                                        onChange={handleChange}
                                    />
                                    {errors.adresse && <div className="invalid-feedback">{errors.adresse}</div>}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                <div className="col-sm-10 mb-2">
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="adressesuite"
                                        value={formData.adressesuite}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label htmlFor="codepostal" className="col-sm-2 col-form-label">
                                    Code postal <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10">
                                    <input
                                        className={`form-control ${errors.postalCode ? 'is-invalid' : ''}`}
                                        type="text"
                                        id="postalCode"
                                        value={postalCode !== null ? postalCode.toString() : ''}
                                        onChange={handleChangeCompanyPostalCode}
                                    />
                                    {errors.postalCode && <div className="invalid-feedback">{errors.postalCode}</div>}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label htmlFor="ville" className="col-sm-2 col-form-label">
                                    Ville <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10">
                                    <select className={`form-control ${errors.ville ? 'is-invalid' : ''}`} id="ville" name="ville" onChange={handleInputChange2}>
                                        {communes.map((commune, index) => (
                                            <option key={index} value={commune}>
                                                {commune}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ville && <div className="invalid-feedback">{errors.ville}</div>}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label htmlFor="Greffe" className="col-sm-2 col-form-label">
                                    Greffe <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className="col-sm-10">
                                    <input
                                        className={`form-control ${errors.greffe ? 'is-invalid' : ''}`}
                                        type="text"
                                        id="greffe"
                                        value={getCityWithPreposition(formData.greffe) || ''}
                                        onChange={handleChange}
                                    />
                                    {errors.greffe && <div className="invalid-feedback">{errors.greffe}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'laGérance' && (
                    <div className="tab-content">
                        {gerants.map((gerant, index) => (
                            <div key={index}>
                                {/* Contenu du formulaire du gérant */}
                                <div className="mb-3 row">
                                    <div className="mb-3 row">
                                        <label htmlFor="personne" className="col-sm-2 col-form-label">Personne</label>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select"
                                                id="personne"
                                                onChange={handleChange}
                                                value={formData.personne}
                                            >
                                                {Personnes.map((option) => (
                                                    <option key={option.value} value={option.label}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {formData.personne === 'Personne physique' && (
                                    <div className="mb-3 row">
                                        <div className="mb-3 row">
                                            <label htmlFor="civilite" className="col-sm-2 col-form-label">Civilité</label>
                                            <div className="col-sm-10">
                                                <select
                                                    className="form-select"
                                                    name="civilite"
                                                    value={gerant.civilite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                >
                                                    {Civilite.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="nom" className="col-sm-2 col-form-label">
                                                Nom <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.nom ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="nom"
                                                    value={gerant.nom}
                                                    onChange={(e) => handleInputChange(index, e)}

                                                />
                                                {errors.nom && <div className="invalid-feedback">{errors.nom}</div>}
                                            </div>
                                            <label htmlFor="prenom" className="col-sm-2 col-form-label">
                                                Prénom <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.prenom ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="prenom"
                                                    value={gerant.prenom}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                                {errors.prenom && <div className="invalid-feedback">{errors.prenom}</div>}

                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">
                                                Adresse <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.adressep ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="adresse"
                                                    value={gerant.adresse}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                                {errors.adressep && <div className="invalid-feedback">{errors.adressep}</div>}
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuite"
                                                    value={gerant.adressesuite}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div className="mb-3 row">
                                            <label htmlFor={`postalCode-${index}`} className="col-sm-2 col-form-label">
                                                Code postal <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.codepostal ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    id={`postalCode-${index}`}
                                                    value={gerant.codepostal}
                                                    onChange={(e) => handleInputChange3(e, index)}
                                                />
                                                {errors.codepostal && <div className="invalid-feedback">{errors.codepostal}</div>}
                                            </div>
                                            <label htmlFor={`ville-${index}`} className="col-sm-2 col-form-label">
                                                Ville <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <select
                                                    className={`form-select ${errors.villep ? 'is-invalid' : ''}`}
                                                    id={`ville-${index}`}
                                                    value={gerant.ville}
                                                    onChange={(e) => handleVilleChange(e, index)}
                                                >
                                                    {gerant.communes.map((commune, idx) => (
                                                        <option key={idx} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.villep && <div className="invalid-feedback">{errors.villep}</div>}
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>
                                )}
                                {formData.personne === 'Personne morale' && (

                                    <div className="mb-3 row">

                                        <div className="mb-3 row">
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">
                                                RCS <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.rcsmorale ? 'is-invalid' : ''}`}
                                                    type="number"
                                                    name="rcs"
                                                    value={gerant.rcs}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length <= 9) {
                                                            handleInputChange(index, e);
                                                        }
                                                    }}
                                                    onFocus={() => setIsFocuseed7(true)}
                                                    onBlur={() => setIsFocuseed7(false)}
                                                />
                                                {errors.rcsmorale && <div className="invalid-feedback">{errors.rcsmorale}</div>}
                                            </div>

                                            <label htmlFor="denomination1" className="col-sm-2 col-form-label">
                                                Dénomination <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.denominationmorale ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="denomination2"
                                                    value={gerant.denomination2 || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                    onFocus={() => setIsFocuseed6(true)}
                                                    onBlur={() => setIsFocuseed6(false)}
                                                />
                                                {errors.denominationmorale && <div className="invalid-feedback">{errors.denominationmorale}</div>}
                                            </div>
                                            {isFocuseed7 && (
                                                <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                    <p style={{
                                                        backgroundColor: '#3EA3B2',
                                                        color: 'white',
                                                        padding: '10px',
                                                        borderRadius: '4px',
                                                        margin: 0,
                                                        width: '30%',
                                                        boxSizing: 'border-box',
                                                        position: 'absolute'
                                                    }}>
                                                        EXPLICATION<br />
                                                        Numéro RCS de la société, exemple : 955 467 946
                                                        Soyez vigilant <br />
                                                        la récupération automatique des données de société dépend de l’INSEE et peut ne pas être à jour.
                                                    </p>
                                                </span>
                                            )}
                                        </div>
                                        {isFocuseed6 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Nom de la société, comme mentionné dans les statuts.
                                                </p>
                                            </span>
                                        )}

                                        <div className="mb-3 row">
                                            <label htmlFor="sociteChoice" className="col-sm-2 col-form-label">
                                                Forme juridique <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className='col-sm-4'>
                                                <select
                                                    className="form-select"
                                                    id="sociteChoice"
                                                    name="sociteChoice"
                                                    onChange={handleSelectChangeSociete}
                                                    value={typeChoice}
                                                >
                                                    {options.map((option, index) => (
                                                        <option key={index} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label htmlFor="adresse" className="col-sm-2 col-form-label">
                                                Adresse <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.adressephysiquemorale ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="adressephysique"
                                                    value={gerant.adressephysique || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                                {errors.adressephysiquemorale && <div className="invalid-feedback">{errors.adressephysiquemorale}</div>}
                                            </div>


                                        </div>
                                        <div className="mb-3 row">
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">Adresse suite</label>
                                            <div className="col-sm-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="adressesuitephysique"
                                                    value={gerant.adressesuitephysique || ""}
                                                    onChange={(e) => handleInputChange(index, e)}
                                                />
                                            </div>
                                            <label htmlFor={`postalCode-${index}`} className="col-sm-2 col-form-label">
                                                Code postal <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.codepostalmorale ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    id={`codepostal3-${index}`}
                                                    value={gerant.codepostal3 || ""}
                                                    onChange={(e) => handleInputChange5(e, index)}
                                                />
                                                {errors.codepostalmorale && <div className="invalid-feedback">{errors.codepostalmorale}</div>}
                                            </div>
                                        </div>
                                        {isFocuseed9 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '170px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Pour une adresse hors France ou Dom-Tom écrire : 00000
                                                </p>
                                            </span>
                                        )}
                                        <div className="mb-3 row">
                                            <label htmlFor={`ville-${index}`} className="col-sm-2 col-form-label">
                                                Ville <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <select
                                                    className={`form-select ${errors.villemorale ? 'is-invalid' : ''}`}
                                                    id={`ville2-${index}`}
                                                    value={gerant.ville2}
                                                    onChange={(e) => handleVilleChange2(e, index)}
                                                >
                                                    {gerant.communes1?.map((commune, idx) => (
                                                        <option key={idx} value={commune}>
                                                            {commune}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.villemorale && <div className="invalid-feedback">{errors.villemorale}</div>}
                                            </div>
                                            <label htmlFor="adressesuite" className="col-sm-2 col-form-label">
                                                Capital <span style={{ color: 'red' }}>*</span>
                                            </label>
                                            <div className="col-sm-4">
                                                <input
                                                    className={`form-control ${errors.capitalmorale ? 'is-invalid' : ''}`}
                                                    type="number"
                                                    id="capital1"
                                                    value={formData.capital1}
                                                    onChange={handleChange}
                                                    onFocus={() => setIsFocuseed8(true)}
                                                    onBlur={() => setIsFocuseed8(false)}

                                                />
                                                {errors.capitalmorale && <div className="invalid-feedback">{errors.capitalmorale}</div>}
                                            </div>
                                        </div>
                                        {isFocuseed8 && (
                                            <span style={{ display: 'block', marginTop: '1px', marginLeft: '670px', marginBottom: '10px' }}>
                                                <p style={{
                                                    backgroundColor: '#3EA3B2',
                                                    color: 'white',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                    margin: 0,
                                                    width: '30%',
                                                    boxSizing: 'border-box'
                                                }}>
                                                    EXPLICATION<br />
                                                    Montant du capital tel que mentionné dans les statuts. Par exemple : 1535,65
                                                </p>
                                            </span>
                                        )}
                                        <label htmlFor="adressesuite" className="col-sm-2 col-form-label">
                                            Greffe <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <div className="col-sm-4">
                                            <input
                                                className={`form-control ${errors.greffemorale ? 'is-invalid' : ''}`}
                                                type="text"
                                                id="greffe1"
                                                value={getCityWithPreposition(formData.greffe1) || ""}
                                                onChange={handleChange}
                                            />
                                            {errors.greffemorale && <div className="invalid-feedback">{errors.greffemorale}</div>}
                                        </div>
                                        {/* Ajout d'une ligne horizontale après chaque gérant sauf le dernier */}
                                        {index < gerants.length - 1 && <hr />}

                                    </div>

                                )}


                            </div>
                        ))}

                        {/* <div className="button-container">
                            <button
                                type="button"
                                className="btn-add"
                                onClick={handleAddGerant}
                            >
                                Ajouter un autre gérant
                            </button>
                            {gerants.length > 1 && (
                                <button
                                    type="button"
                                    className="btn-remove"
                                    onClick={handleRemoveLastGerant}
                                >
                                    Supprimer le dernier gérant
                                </button>
                            )}
                        </div> */}
                        {submittedData && (
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    onChange={handleChange}
                                    disabled
                                />
                            </div>
                        )}
                    </div>
                )}

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {activeTab !== 'raisonSociale' && (
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious} >
                                Modifier mon annonce
                            </button>
                        )}
                        {activeTab === 'laGérance' && (
                            <button type="submit" onClick={handleNext}>Mettre à jour mon annonce</button>
                        )}

                        {activeTab !== 'laGérance' && (
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext} >
                                Suivant
                            </button>
                        )}

                        {formSubmitted && activeTab === 'laGérance' && (
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse} >
                                Suivant
                            </button>

                        )}
                    </div>
                </div>
            </form>

            {/* Boutons Précédent et Suivant */}
            {/* Boutons Précédent, Soumettre et Suivant */}




        </>
    );
};

export default CreationAutreHorsForfait;